<script>
import TheHeader from "@/components/index/TheHeader.vue";

export default {
  components: {
    TheHeader
  },
  data() {
    return {
      finished: false
    };
  },
  mounted() {
    this.finished = true;
  },
  methods: {
    downloadChrome() {
      window.open("https://www.google.cn/chrome/?standalone=1&platform=win64");
    },
    downloadIE() {
      window.open(
        "https://support.microsoft.com/zh-cn/help/18520/download-internet-explorer-11-offline-installer"
      );
    },
    exit() {
      // let type = localStorage.getItem("type");
      // if(type === "saveBtnClicked"){

      // }else{
      //     this.$router.replace('/firstscreendetect');
      // }
      this.$router.replace("/index/homeRoute");
    }
  }
};
</script>
<template>
  <div
    class="BrowserTip"
    v-loading.fullscreen.lock="!finished"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <TheHeader />
    <div class="content">
      <img class="browserbg" src="../../assets/browserbg.svg" alt />
      <div class="right">
        <h2>发现更好的使用体验</h2>
        <span class="tip_text">推荐使用Internet Explorer 11及以上 ，Chrome浏览器54.0.2840.71及以上获得更完整的体验</span>
        <div class="browserDow">
          <div class="chrome">
            <img src="../../assets/chrome.png" alt @click="downloadChrome" />
            <span @click="downloadChrome">Chrome54.0.2840.71</span>
          </div>
          <div class="line"></div>
          <div class="ie">
            <img src="../../assets/ie.png" alt @click="downloadIE" />
            <span @click="downloadIE">Internet Explorer 11</span>
          </div>
        </div>
        <div class="exit">
          <span @click="exit">跳过>></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content {
  width: calc(100vw - 30px);
  height: calc(100vh - 65px - 30px);
  box-sizing: border-box;
  flex-grow: 1;
  margin: 15px;
  background-color: #fff;
  border-radius: 5px;
  padding-right: 50px;
  overflow: auto;
  .browserbg {
    margin-top: 15%;
    margin-left: 10%;
  }
  .right {
    position: absolute;
    top: 30%;
    left: 50%;
  }
  h2 {
    font-family: "PingFangSC-Regular";
    font-size: 18px;
    color: #020202;
    letter-spacing: 0;
    margin-bottom: 15px;
  }
  .tip_text {
    display: inline-block;
    font-family: "PingFangSC-Regular";
    font-size: 14px;
    color: #3c3c3c;
    letter-spacing: 0;
    margin-bottom: 40px;
  }
  .browserDow {
    display: flex;
    margin-bottom: 25px;
    .line {
      width: 2px;
      height: 72px;
      background-color: #f3f3f3;
      margin-left: 50px;
      margin-right: 50px;
    }
    img {
      display: block;
      margin: 0 auto;
      cursor: pointer;
    }
    span {
      display: inline-block;
      margin-top: 10px;
      font-family: "PingFangSC-Regular";
      font-size: 12px;
      color: #3c3c3c;
      letter-spacing: 0;
      cursor: pointer;
    }
    .chrome {
      margin-top: 5px;
    }
  }
  .exit {
    font-family: "PingFangSC-Regular";
    font-size: 14px;
    color: #00c1de;
    letter-spacing: 0;
    span {
      cursor: pointer;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/browserTip/BrowserTip.vue